import styled from 'styled-components';
import Link from 'next/link';

export const StaticContainer = styled.div`
  padding: 15px 0;
  width: 960px;

  @media screen and (max-width: ${({ theme }) => theme.desktopBreakpoint}) {
    width: 100%;
    padding: 15px 40px 0 40px;
  }

  @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 15px 15px 0 15px;
  }
`;

export const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.systemColors.blue};
`;
